import BaseComponent from "../../baseComponent.js";
import IdentityAccessService from "../../../core/services/identityAccessService";

import styles from './styles.scss';

export default class APIKeyManagement extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      keys: []
    };
  }

  deleteKey(key) {
    IdentityAccessService.deleteApiKey(key).then(() => {
      this.setState({
        keys: this.state.keys.filter(k => k.key !== key)
      });
    });
  }

  componentDidMount() {
    IdentityAccessService.getApiKeys().then(keys => {
      this.setState({
        keys
      });
    });
  }

  render() {
    return (
      <div className={styles.container}>
        <table>
          <thead>
            <tr>
              <th>Key</th>
              <th>Expire</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {
              this.state.keys.map((k, i) => (
                <tr key={i}>
                  <td>{k.key}</td>
                  <td>{k.expire}</td>
                  <td>
                    <div className={styles.delete}>
                      <i className="material-icons" onClick={() => this.deleteKey(k.key)}>delete</i>
                    </div>
                  </td>
                </tr>
              ))
            }
          </tbody>
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/profile/api-key-management/apiKeyManagement.jsx